import React, { useState } from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import "./togglebuttons.css";
import { FormLabel, Stack } from "@mui/material";
import IntentType from "../../../intentexecutor/utils/IntentType";
import ErrorNotificationComponent from "../../../components/generic/error/ErrorNotificationComponent";
import { performPostRequest } from "../../../service/network/NetworkService";
import { getApiUrl } from "../../../service/network/UrlMapper";

const ToggleButtons = ({ label, configKey, role, organizationIdentifier }) => {
  const [featureVisibility, setFeatureVisibility] = useState(null);

  const handleChange = (event, newVisibility) => {
    if (newVisibility !== null) {
      setFeatureVisibility(newVisibility);
      setVisibilityConfig(newVisibility);
    }
  };

  const setVisibilityConfig = async (visibility) => {
    const configurationValue = { visibility };

    const payload = {
      intent: "add_configuration",
      payload: {
        configurationKey: configKey,
        configurationValue: JSON.stringify(configurationValue),
      },
      context: {
        role,
        organizationIdentifier,
      },
    };

    try {
      const response = await performPostRequest(
        getApiUrl()[IntentType.ADD_CONFIGURATION],
        JSON.stringify(payload)
      );
      await response.json();
    } catch (error) {
      ErrorNotificationComponent(error);
    }
  };

  React.useEffect(() => {
    const getVisibilityConfig = async () => {
      const payload = {
        intent: "get_configuration",
        payload: {
          configurationKey: [configKey],
        },
        context: {
          role,
          organizationIdentifier,
        },
      };

      try {
        const response = await performPostRequest(
          getApiUrl()[IntentType.GET_CONFIGURATION],
          JSON.stringify(payload)
        );
        const result = await response.json();
        const configurationValue = JSON.parse(
          result[0]?.configurationValue || "{}"
        );
        setFeatureVisibility(configurationValue?.visibility);
      } catch (error) {
        ErrorNotificationComponent(error);
      }
    };

    getVisibilityConfig();
  }, [configKey, organizationIdentifier, role]);

  return (
    <Stack
      direction="row"
      spacing={4}
      sx={{
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <FormLabel>{label}</FormLabel>
      <ToggleButtonGroup
        value={featureVisibility}
        exclusive
        onChange={handleChange}
        aria-label="Platform"
        className="visibility-toggle-buttons"
      >
        <ToggleButton value={true}>Yes</ToggleButton>
        <ToggleButton value={false}>No</ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  );
};

export default ToggleButtons;
